module.exports = __webpack_public_path__ + "img/old_Boston.8160c97f.jpg";